import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getUrlExpeditionApi, isNullOrEmpty } from '../../../utils/util';
import { startLoading, endLoading } from '../../../actions/loadingAction';

const ConfirmPackListEmail = (props) => {
    const [result, setResult] = useState({
        success: false,
        message: ""
    });
    const renderToken = () => {
        if (props?.location?.search) {
            return props?.location?.search.replace("?token=", "");
        }
    }

    useEffect(() => {
        if (!isNullOrEmpty(renderToken())) {
            send();
        }
        // eslint-disable-next-line
    }, []);


    const send = () => {
        const uri = `${getUrlExpeditionApi(window)}/api/packlist/approve/email`;
        const token = renderToken();
        props.showLoading();
        var objToken = JSON.parse(atob(token))

        return axios.post(uri, { token }, {
            headers: {
                'Authorization': `Bearer ${objToken.tokeAplication}`
            }
        }).then((response) => {
            if (response && response.data) {
                setResult({ ...response.data });
            }
        }).catch((error) => {
            result.message = error.response?.data?.message || error.message
            result.success = false
            setResult({ ...result })
            return error;
        }).finally(() => {
            props.endLoading();
        });
    };

    return (
        <div>
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        Aprovação Romaneio
                    </div>
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '40px' }}>
                <div className='row' style={{ padding: '10px' }}>
                    <div className="input-field no-padding col s12">
                        Status : {result.success ? "Sucesso" : "Erro"}
                    </div>
                    <div className="input-field no-padding col s12">
                        Mensagem : {result.success ? result.Approved ? "Aprovado" : "Reprovado" : result.message}
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        inventory: state.lineInventoryReducer.inventory,
        inventoryConfig: state.lineInventoryReducer.inventoryConfig,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        showLoading: () => {
            dispatch(startLoading());
        },
        endLoading: () => {
            dispatch(endLoading());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)((ConfirmPackListEmail)));

